export const ALL_ORDER_REQUEST = "ALL_ORDER_REQUEST";
export const ALL_ORDER_SUCCESS = "ALL_ORDER_SUCCESS";
export const ALL_ORDER_FAIL = "ALL_ORDER_FAIL"